import {
  ManageDocumentDialog,
  type ManageDocumentHooks,
  type RoomDocument,
} from '@dataroom/shared';
import {
  useAddCategoryAndFile,
  useModifyDocumentAttributes,
  useReclassifyDocument,
  useRoomCategories,
  useSetDocumentDating,
} from '@/api/hooks';

/** The seller side's hooks for the shared "Manage document" dialog (module-level:
 * stable identities). No AI-suggestion Confirm / Reject — that is the admin's —
 * but "Add a new subfolder…" and "Re-file with AI" are the seller's here. */
const SELLER_HOOKS: ManageDocumentHooks = {
  useCategories: useRoomCategories,
  useFile: useModifyDocumentAttributes,
  useDating: useSetDocumentDating,
  useAddCategory: useAddCategoryAndFile,
  useReclassify: useReclassifyDocument,
};

/**
 * "Manage document" in the seller portal (owner decision 2026-10-21): the same
 * dialog the room admin uses — where the document is filed, its period and its
 * date of data — for the bound seller and the seller's team. Every change is
 * saved under their own name and shows in the room's Activity.
 */
export function SellerManageDocumentDialog({
  roomId,
  document,
  onClose,
}: {
  roomId: string;
  /** The LIVE document (re-read from the polled listing). */
  document: RoomDocument;
  onClose: () => void;
}) {
  return (
    <ManageDocumentDialog
      roomId={roomId}
      document={document}
      onClose={onClose}
      hooks={SELLER_HOOKS}
    />
  );
}
